import { PlaneBufferGeometry, SphereBufferGeometry, BoxBufferGeometry, MeshBasicMaterial, RepeatWrapping } from 'three';

export const simplePlaneGeometry = new PlaneBufferGeometry(1, 1);
export const simpleSphereGeometry = new SphereBufferGeometry(1, 32, 32);
export const simpleCubeGeometry = new BoxBufferGeometry(1, 1, 1);
export const simpleMaterial = (color = 'blue', transparent = false) => new MeshBasicMaterial({ color, transparent });
export const simpleMaterialMap = (map) => new MeshBasicMaterial({ map, transparent: true });
export const simpleVs = /* glsl */ `
	varying vec2 vUv;
	void main() {
		vUv = uv;
		vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
		gl_Position = projectionMatrix * mvPosition;
	}
`;
export const simpleFs = /* glsl */ `
	uniform sampler2D uTexture;
	varying vec2 vUv;
	void main() {
		vec4 tDiffuse = texture2D(uTexture, vUv);
		gl_FragColor = tDiffuse;
	}
`;
export const materialEasyUniforms = (ctx, uniforms) => {
    Object.keys(uniforms || ctx.uniforms).forEach((key) => {
        Object.defineProperty(ctx, key, {
            get: () => ctx.uniforms[key].value,
            set: (val) => {
                ctx.uniforms[key].value = val;
            },
        });
    });
};

export const repeatTexture = (t) => {
    t.wrapS = t.wrapT = RepeatWrapping;
    t.needsUpdate = true;
    return t;
};
